import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveIcon from "@mui/icons-material/Remove";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import lineBreak from "../../../utils/lineBreak";

export default function CardsImageResponse() {
  const { t } = useTranslation();
  const [jsonFinal, setJsonFinal] = useState<string>("");
  const [title, setTitle] = useState<string>("");

  const [value, setValue] = useState<any>({
    description: "",
    image_id: "",
  });

  const [values, setValues] = useState<any[]>([]);

  const generate = () => {
    const concat = lineBreak(title);
    values.forEach((item) => {
      if (item.description) {
        item.description = item.description.replaceAll("\\n", "\n");
      }
      if (item.image_id) {
        item.image_id = item.image_id.replaceAll("\\n", "\n");
      }
    });

    const jsonGerado = {
      generic: [
        {
          response_type: "text",
          values: [
            {
              text_expression: {
                concat,
              },
            },
          ],
          selection_policy: "sequential",
        },
        {
          user_defined: {
            type: "cards_image",
            value: {
              cards_image: {
                steps: values,
              },
            },
          },
          response_type: "user_defined",
        },
      ],
    };
    setJsonFinal(JSON.stringify(jsonGerado, null, 2));
  };

  const clear = () => {
    setValues([]);
    setValue({
      description: "",
      image_id: "",
    });
    setJsonFinal("");
    setTitle("");
  };

  return (
    <Grid container>
      <Grid container size={12} sx={{ marginBottom: 2 }}>
        <Grid size={12}>
          <TextField
            multiline
            rows="4"
            fullWidth
            id="outlined-basic"
            label={t("transformJson.title")}
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container size={12} spacing={1} sx={{ marginBottom: 2 }}>
        <Grid size={5}>
          <TextField
            fullWidth
            size="small"
            id="outlined-basic"
            label={t("transformJson.idImage")}
            variant="outlined"
            value={value.image_id || ""}
            onChange={(e) => setValue({ ...value, image_id: e.target.value })}
          />
        </Grid>
        <Grid size={5}>
          <TextField
            fullWidth
            size="small"
            id="outlined-basic"
            label={t("transformJson.description")}
            variant="outlined"
            value={value.description || ""}
            onChange={(e) =>
              setValue({ ...value, description: e.target.value })
            }
          />
        </Grid>
        <Grid size="auto">
          <IconButton
            color="primary"
            aria-label="add"
            disabled={
              value.description !== "" && value.image_id !== "" ? false : true
            }
            onClick={() => {
              setValues([...values, value]);
              setValue({
                description: "",
                image_id: "",
              });
            }}
          >
            <AddIcon />
          </IconButton>
        </Grid>
      </Grid>
      {values.map((aux: any, index: number) => {
        return (
          <Grid
            key={`${aux.image_id}-${index}`}
            container
            sx={{ marginBottom: 2 }}
          >
            <Grid size={5}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                label={t("transformJson.idImage")}
                variant="outlined"
                value={aux.image_id || ""}
                onChange={(e) => {
                  const newArr = [...values];
                  newArr[index].image_id = e.target.value;
                  setValues(newArr);
                }}
              />
            </Grid>
            <Grid size={5}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                label={t("transformJson.description")}
                variant="outlined"
                value={aux.description || ""}
                onChange={(e) => {
                  const newArr = [...values];
                  newArr[index].description = e.target.value;
                  setValues(newArr);
                }}
              />
            </Grid>
            <Grid size="auto">
              <IconButton
                color="primary"
                aria-label="remove"
                onClick={() => {
                  const newArr = [...values];
                  newArr.splice(index, 1);
                  setValues(newArr);
                }}
              >
                <RemoveIcon />
              </IconButton>
            </Grid>
          </Grid>
        );
      })}
      <Grid container spacing={2} sx={{ marginBottom: 1 }}>
        <Grid>
          <Button
            variant="contained"
            sx={{ marginTop: "8px" }}
            disabled={title === "" || values.length === 0 ? true : false}
            onClick={generate}
          >
            {t("button.Generate")}
          </Button>
        </Grid>
        <Grid>
          <Button variant="contained" sx={{ marginTop: "8px" }} onClick={clear}>
            {t("button.Clean")}
          </Button>
        </Grid>
      </Grid>
      <Grid container size={12} sx={{ flexDirection: "column" }}>
        <Grid>
          <pre
            style={{
              wordWrap: "break-word",
              maxWidth: "37rem",
              whiteSpace: "pre-wrap",
            }}
          >
            {jsonFinal}
          </pre>
        </Grid>
        <Grid>
          {jsonFinal !== "" ? (
            <Button
              disabled={false}
              variant="contained"
              onClick={() => {
                navigator.clipboard.writeText(jsonFinal);
              }}
              startIcon={<ContentCopyIcon />}
            >
              {t("button.Copy")}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
}
